import React, { Component } from "react";
import { Link } from "react-router-dom";

const SubmenuAcceso = ({ mobile, ocultarMenu }) => {

  return (
    <div 
    style={mobile?
    {
      position: "relative",
      left: "5%",
      top: 20,
      width: "auto",
      background: "#ffffff",
    }:
    {
      position: "absolute",
      top: 80,
      width: 175,
      marginLeft: -87.5+12.5,
      height: 82,
      display: "flex",
      justifyContent: "space-between",
      background: "#FFFFFF",
      paddingLeft: 20,
      paddingTop: 10,
      paddingBottom: 10,
      paddingRight: 20,
      borderBottomLeftRadius: 20,
      borderBottomRightRadius: 20,
      borderBottom: "solid",
      borderBottomWidth: 1,
      borderBottomColor: "#e5e8e9",
      borderLeft: "solid",
      borderLeftWidth: 1,
      borderLeftColor: "#e5e8e9",
      borderRight: "solid",
      borderRightWidth: 1,
      borderRightColor: "#e5e8e9"
    }}>
      <div>
      <Link
          onClick={ocultarMenu}
          to="/comerciantes/login"
        >
          <div className="categoria_submenu">Como comercio</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/profesionales/login"
        >
          <div className="categoria_submenu">Como profesional</div>
        </Link>
      </div>
    </div>
  );
};

export default SubmenuAcceso;
